export default "__VITE_ASSET__Bqum1yJP__"